"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentedControl = SegmentedControl;
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _buttonStyle = require("../../common/buttonStyle");
var _classes = require("../../common/classes");
var _ToggleButton = require("../button/ToggleButton");
var _Tooltip = require("../tooltip/Tooltip");
var _excluded = ["className", "items", "large", "minimal", "small"],
  _excluded2 = ["id"],
  _excluded3 = ["defaultToggled", "id", "isControlled", "minimal", "onClick", "toggled", "tooltipProps"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * This component is somewhat similar to the Blueprint `ButtonGroup` in that it wraps some buttons
 * The main difference is that we don't allow children, and instead require our content to be
 * passed through in an items array. The reason we do this is so we can control the state and style,
 * which is not possible with the ButtonGroup as its more basic.
 */

function SegmentedControl(_ref) {
  var className = _ref.className,
    items = _ref.items,
    large = _ref.large,
    _ref$minimal = _ref.minimal,
    minimal = _ref$minimal === void 0 ? false : _ref$minimal,
    small = _ref.small,
    props = _objectWithoutProperties(_ref, _excluded);
  /**
   * We need to be able to perform different behavior if we're acting in a controlled mode
   * We'll only allow controlled mode if we validate that all `toggle` values passed into our items are not undefined.
   */
  var isControlled = items.every(function (item) {
    return item.toggled !== undefined;
  });
  var classes = (0, _classnames.default)([_classes.Classes.SEGMENTED_CONTROL, className]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), items.map(function (_ref2) {
    var id = _ref2.id,
      itemProps = _objectWithoutProperties(_ref2, _excluded2);
    return /*#__PURE__*/React.createElement(SegmentedControlButton, _extends({
      key: id,
      id: id,
      isControlled: isControlled,
      large: large,
      minimal: minimal,
      small: small
    }, itemProps));
  }));
}
function SegmentedControlButton(_ref3) {
  var _ref3$defaultToggled = _ref3.defaultToggled,
    defaultToggled = _ref3$defaultToggled === void 0 ? false : _ref3$defaultToggled,
    id = _ref3.id,
    isControlled = _ref3.isControlled,
    _ref3$minimal = _ref3.minimal,
    minimal = _ref3$minimal === void 0 ? false : _ref3$minimal,
    onClick = _ref3.onClick,
    _ref3$toggled = _ref3.toggled,
    controlledToggled = _ref3$toggled === void 0 ? false : _ref3$toggled,
    tooltipProps = _ref3.tooltipProps,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var _React$useState = React.useState(isControlled ? controlledToggled : defaultToggled),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    toggled = _React$useState2[0],
    setToggled = _React$useState2[1];
  React.useEffect(function () {
    if (isControlled) setToggled(controlledToggled);
  }, [controlledToggled, isControlled]);
  var minimalButtonStyle = toggled ? _buttonStyle.ButtonStyle.SECONDARY : _buttonStyle.ButtonStyle.TERTIARY;
  var nonMutedButtonStyle = toggled ? _buttonStyle.ButtonStyle.POSITIVE : _buttonStyle.ButtonStyle.TERTIARY;
  var buttonStyle = minimal ? minimalButtonStyle : nonMutedButtonStyle;
  function handleClick() {
    if (!isControlled) setToggled(!toggled);
    onClick(id);
  }
  var toggleButton = /*#__PURE__*/React.createElement(_ToggleButton.ToggleButton, _extends({}, props, {
    buttonStyle: buttonStyle,
    minimal: minimal,
    onClick: handleClick
  }));
  return tooltipProps ? /*#__PURE__*/React.createElement(_Tooltip.Tooltip, tooltipProps, toggleButton) : toggleButton;
}